module.exports = __webpack_public_path__ + "static/media/miranda.f5213987.jpg";